/* global Wahanda */
export default Wahanda;
